import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";
import Datenschutz from "./pages/Datenschutz";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <div className="App min-h-screen bg-[#09090b] text-white grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#121217",
            border: "1px solid #27272a",
            color: "#ffffff",
          },
        }}
      />
    </div>
  );
}
